import type { Usuario } from "@/ts/typings/clases";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { asignarCicloUsuario, eliminarCicloUsuario, usePersonalAsignado, useUsuriosDisponibles, type UsuarioAsignado } from "./ModalSeleccionarPersonal";
import { CommonFeatures } from "@/hooks/useTanstackTable";
import { toast } from "react-toastify";

export function TablaPersonalCiclo(props: { readonly idCiclo: number | null; }) {
	const queryClient = useQueryClient();
	const { data, error, isPending } = useUsuriosDisponibles();
	const { data: dataPersonal, error: errorPersonal, isPending: isPendingPersonal } = usePersonalAsignado({
		idCiclo: props.idCiclo ?? null,
	});


	const onSeleccionarPersonal = useCallback((row: Usuario, matchStatus: "match" | "") => {
		if (props.idCiclo == null) {
			toast("Error al asignar el ciclo", { type: "error" });
			throw new Error("Error: IdCiclo es null");
		}

		if (matchStatus === "match") {
			void eliminarCicloUsuario(props.idCiclo, Number(row.id), queryClient);
		} else {
			void asignarCicloUsuario(props.idCiclo, Number(row.id), queryClient);
		}
	}, [props.idCiclo, queryClient]);

	const { columns, features } = useMemo(
		() => Columns(dataPersonal, onSeleccionarPersonal, props.idCiclo),
		[dataPersonal, onSeleccionarPersonal, props.idCiclo]
	);


	return (
		<TypedTable
			className="dataTable display"
			columns={columns}
			features={features}
			data={data ?? []}
			pagination

			noResultsMessage="No se encontraron pedidos"
			errorMessage={(error ?? errorPersonal)?.message ?? "Error al cargar los pedidos"}
			isLoading={isPending || isPendingPersonal}
			isError={(error ?? errorPersonal) != null}
		/>
	);
}

function Columns(dataPersonal: UsuarioAsignado[] | undefined, onSeleccionarPersonal: (row: Usuario, matchStatus: "match" | "") => void, idCiclo: number | null) {
	const columnHelper = createColumnHelper<typeof features, Usuario>();
	const features = tableFeatures(CommonFeatures);

	const nom = (linea: Usuario) => `${linea.nombre} ${linea.apellido}`;
	const getRol = (linea: Usuario) => {
		let rol;
		switch (linea.rol as string) {
			case "jefeFabrica": rol = "Jefe de fabrica"; break;
			default: rol = linea.rol;
		}
		return rol;
	};
	const accionSeleccion = (linea: Usuario) => {
		const match = dataPersonal?.some((personal) => {
			if (personal.representante_id === Number(linea.id)) {
				if (personal.ciclo_id === idCiclo) {
					return true;
				}
			}
			return false;
		}) ?? false;

		return (
			<div
				className={`seleccionarPersonal ${match}`}
				onClick={() => { onSeleccionarPersonal(linea, match ? "match" : ""); }}
			/>
		);
	};
	const columns = columnHelper.columns([
		columnHelper.accessor(nom, { header: "Nombre", meta: { className: "dt-center" } }),
		columnHelper.accessor(getRol, { header: "Rol", meta: { className: "dt-center" } }),
		columnHelper.display({
			id: "acciones",
			header: "",
			cell: ({ row }) => accionSeleccion(row.original),
		})
	]);

	return { columns, features };
}
